<template>
  <v-container fluid py-0 style="background-color: #E4E7EA;">
    <v-container>
      <v-row class="justify-center pt-6 pt-sm-10">
        <v-container>
          <v-row>
            <v-col cols="12">
              <div class="font-weight-medium secondary--text section-title">
                {{ $t('contacts') }}
              </div>
            </v-col>
            <v-col cols="12">
              <div class="primary--text">
                {{
                  $t('contacts_intro')
                }}
              </div>
            </v-col>

            <v-col cols="12" md="6" sm="8" class="text-center">
              <router-link style="width: 100%; color: white; text-decoration: none;" to="/preuzimanje-identiteta" :to="`${$route.params.lang === 'en' ? '/en' : ''}/preuzimanje-identiteta`">
                <div class="login-btn accent elevation-0">
                  <span class="login-btn-icon"><img class="px-3 mt-3" height="30px" :src="require('@/assets/edu-logo-white.svg')"/></span>
                  <div class="login-btn-text">
                    <!--                <v-icon color="white" class="pr-2 text-body-2 text-md-body-1">mdi-shield-check</v-icon>-->
                    <span class="text-body-2 text-md-body-1 white--text">{{ $t('no_identity') }}</span>
                  </div>
                </div>
              </router-link>

            </v-col>


            <v-col cols="12" class="mt-10">
              <div id="koordinatori" class="font-weight-medium secondary--text section-title">
                {{ $t('sumit_coords_at_fac') }}
              </div>
            </v-col>
<!--            <v-row align="center" justify="center">-->

<!--            </v-row>-->
            <v-col cols="12">
              <v-data-table
                :items="coordinators"
                :headers="headers"
                disable-sort
                class="primary--text mb-10"
                hide-default-footer
                disable-pagination
              >
                <template v-slot:[`item.institution`]="{ item }">
                  <div class="d-flex flex-column">
                    <span>{{ $t(item.institution) }}</span>
                  </div>
                </template>
                <template v-slot:[`item.contact`]="{ item }">
                  <div class="d-flex flex-column">
                    <span>{{ item.contact }}</span>
                    <a
                      class="font-weight-medium"
                      :href="item.contact_email"
                      style="text-decoration:none;"
                      >{{ item.contact_email }}</a
                    >
                  </div>
                  <div v-if="item.contact2" class="d-flex flex-column mt-2">
                    <span>{{ item.contact2 }}</span>
                    <a
                      class="font-weight-medium"
                      :href="item.contact2_email"
                      style="text-decoration:none;"
                      >{{ item.contact2_email }}</a
                    >
                  </div>
                </template>
              </v-data-table>
            </v-col>


            <v-col cols="12" class="mt-10">
              <div id="koordinatori" class="font-weight-medium secondary--text section-title">
                {{ $t('sumit_school_cord') }}
              </div>
            </v-col>
            <v-col>
              <div id="main-panels" style="padding-bottom: 0 !important;">
                <v-expansion-panels accordion>
                  <v-expansion-panel
                      class="mb-4 panel"
                      v-for="(county, i) in counties"
                      :key="i"
                  >
                    <v-expansion-panel-header
                        id="panel-header"
                        class="text-none"
                        disable-icon-rotate
                    >
                      <v-icon slot="actions" color="secondary"
                      >mdi-unfold-more-horizontal</v-icon
                      >
                      <span
                          class="secondary--text font-weight-medium text-body-1 text-sm-h5"
                      >{{ county.title }}</span
                      >
                    </v-expansion-panel-header>
                    <v-expansion-panel-content
                        class="flex-column primary--text county-content font-weight-medium"
                        style="background-color: #f4f6f8; border-radius: 8px"
                    >
                      <div class="py-6 py-sm-10">
                        <div
                            class="text-body-1 text-sm-h6 mb-4 font-weight-medium"
                        >
                          {{ $t('municipalities') }}
                        </div>
                        <v-expansion-panels id="city-panels" accordion>
                          <v-expansion-panel
                              v-for="(city, j) in county.townships"
                              :key="j"
                              class="mb-3 panel"
                          >
                            <v-expansion-panel-header
                                class="text-none py-3 py-sm-0 px-2 px-sm-6"
                                style="min-height: 60px;"
                                disable-icon-rotate
                            >
                              <v-icon slot="actions" color="primary"
                              >mdi-unfold-more-horizontal</v-icon
                              >
                              <span
                                  class="secondary--text font-weight-medium text-body-1"
                              >{{ city.title }}</span
                              >
                            </v-expansion-panel-header>
                            <v-expansion-panel-content
                                class="flex-column primary--text font-weight-medium"
                            >
                              <v-row v-for="(school, k) in city.schools" :key="k">
                                <v-col>
                                  <div class="d-flex flex-column flex-sm-row">
                                    <v-avatar
                                        color="accent"
                                        width="32"
                                        min-width="32"
                                        min-height="32"
                                        height="32"
                                        class="mr-6 mb-3 mb-sm-0"
                                    >
                                      <v-icon color="white" size="18"
                                      >mdi-domain</v-icon
                                      >
                                    </v-avatar>
                                    <div>
                                      <p class="secondary--text mb-2">
                                        {{ school.name }}
                                      </p>
                                      <div style="font-size: 14px;">
                                        <span class="font-weight-regular"
                                        >E-mail:
                                        </span>
                                        <a
                                            style="text-decoration: none; word-break: break-all;"
                                            :href="school.contact_email"
                                        >{{ school.contact_email }}</a
                                        >
                                      </div>
                                      <div style="font-size: 14px;">
                                        <span class="font-weight-regular"
                                        >{{ $t('contact_sumit_coord') }}
                                        </span>
                                        <span v-for="(coordinator, index) in school.coordinators" :key="coordinator.id">
                                          <a
                                              style="text-decoration: none; word-break: break-all;"
                                              :href="coordinator.email"
                                          >{{ coordinator.email }}<span v-if="index < (school.coordinators.length - 1)"> - </span>
                                          </a>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    counties: [],
    headers_hr: [
      { text: "Ime ustanove", value: "institution" },
      { text: "Kontakt osoba", value: "contact" }
    ],
    headers_en: [
      { text: "Name of the institution", value: "institution" },
      { text: "Contact person", value: "contact" }
    ],
    coordinators: [
      {
        institution: "aptf",
        contact: "Jurica Primorac",
        contact_email: "jurica.primorac@aptf.sum.ba"
      },
      {
        institution: "alu",
        contact: "Nikol Zadro",
        contact_email: "nikol.zadro@alu.sum.ba"
      },
      {
        institution: "ef",
        contact: "Mirela Mabić",
        contact_email: "mirela.mabic@ef.sum.ba",
        contact2: "Damir Lucović",
        contact2_email: "damir.lucovic@ef.sum.ba"
      },
      {
        institution: "gf",
        contact: "Božo Penavić",
        contact_email: "bozo.penavic@fgag.sum.ba"
      },
      {
        institution: "fpmoz",
        contact: "Ivana Čerkez Zovko",
        contact_email: "ivana.cerkez.zovko@fpmoz.sum.ba"
      },
      {
        institution: "fsre",
        contact: "Ivan Markić",
        contact_email: "ivan.markic@fsre.sum.ba"
      },
      {
        institution: "fzs",
        contact: "Toni Perić",
        contact_email: "toni.peric@fzs.sum.ba"
      },
      {
        institution: "farf",
        contact: "Franjo Jurilj",
        contact_email: "franjo.jurilj@farf.sum.ba"
      },
      {
        institution: "ff",
        contact: "Krešimir Čavar",
        contact_email: "kresimir.cavar@ff.sum.ba"
      },
      {
        institution: "mef",
        contact: "Mario Prskalo",
        contact_email: "mario.prskalo@mef.sum.ba"
      },
      {
        institution: "pf",
        contact: "Marko Smiljanić",
        contact_email: "marko.smiljanic@pf.sum.ba"
      }
    ]
  }),
  computed: {
    headers() {
      return this.$route.params.lang === 'en' ? this.headers_en : this.headers_hr
    }
  },
  created() {
    this.getData();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    getData() {
      this.$axios
        .get("https://test-api-skole.sum.ba/pub/contact/info")
        .then(response => {
          this.counties = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style>
#city-panels .v-expansion-panel::before {
  box-shadow: 0px 10px 20px rgba(40, 44, 53, 0.1) !important;
}

.county-content .v-expansion-panel-content__wrap {
  padding: 0 40px 16px;
}

@media only screen and (max-width: 1200px) {
  .county-content .v-expansion-panel-content__wrap {
    padding: 0 24px 16px;
  }
}

@media only screen and (max-width: 600px) {
  .county-content .v-expansion-panel-content__wrap {
    padding: 0 16px 16px;
  }
}
</style>
